module.exports = require("./bs-Cyrl.d.ts");